import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { getSubCategoriesByCategoryId } from "../../utils/urls";
import AdvisorConditionsModal from "../common/AdvisorConditionsModal";
import AddLeadPopup from "../Leads/AddLeadPopup";
import { useSelector } from "react-redux";
import AddLeadModal from "../common/AddLeadModal/AddLeadModal";

const SubCategoryPage = () => {
  const { categoryId } = useParams();
  const navigate = useNavigate();
  const loggedInUser = useSelector((state) => state.auth);
  const [subCategories, setSubCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isAddLeadOpen, setIsAddLeadOpen] = useState(false);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);

  useEffect(() => {
    const fetchSubCategories = async () => {
      try {
        const response = await axios.get(
          getSubCategoriesByCategoryId(categoryId) + "?is_all=true"
        );
        if (response.data.success) {
          // console.log("response.data.data", response.data.data);
          setSubCategories(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching subCategories:", error);
      } finally {
        setLoading(false);
      }
    };
    if (categoryId) {
      fetchSubCategories();
    }
  }, [categoryId]);

  const handleAddNewLead = async (_sub) => {
    if (_sub) {
      if (
        loggedInUser?.user?.advisor_onboarding_status_id?.title === "Approved"
      ) {
        console.log("sub", _sub);
        
        setSelectedSubCategory(_sub);
        setIsAddLeadOpen(true);
      } else {
        const confirmed = await AdvisorConditionsModal.show(navigate);
        console.log("confirmed", confirmed);
      }
    }
  };

  return (
    <>
      <div className="page-container">
        <h1 className="text-2xl font-bold text-blue-600 mb-8 border-b border-gray-200 pb-4">
          Sub-Categories
        </h1>

        {loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {Array(6).fill(null).map((_, i) => (
              <div key={i} className="bg-white rounded-xl border border-[#E2EBF3] p-5 flex flex-row items-center gap-4 animate-pulse">
                <div className="w-16 h-16 rounded-xl bg-[#EAF4FF] flex-shrink-0" />
                <div className="flex flex-col flex-1 gap-2">
                  <div className="h-4 bg-[#E2EBF3] rounded w-1/2" />
                  <div className="h-3 bg-[#E2EBF3] rounded w-full" />
                  <div className="h-3 bg-[#E2EBF3] rounded w-3/4" />
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {subCategories.map((sub) => (
              <div
                key={sub.sub_category_id}
                onClick={() => {
                  if (sub?.category_id?.is_lead_add_without_product) {
                    handleAddNewLead(sub);
                  } else {
                    navigate(`/products/list/${categoryId}/${sub.sub_category_id}`);
                  }
                }}
                className="group flex flex-row items-center gap-4 rounded-xl border border-[#E2EBF3] p-5 bg-white text-left cursor-pointer hover:border-[#0184FF] hover:shadow-[0_4px_16px_rgba(1,132,255,0.12)] hover:-translate-y-[2px] transition-all duration-200"
              >
                <div className="w-16 h-16 rounded-xl bg-[#EAF4FF] flex items-center justify-center flex-shrink-0 overflow-hidden transition-transform duration-200 group-hover:scale-105">
                  {sub.logo_url ? (
                    <img
                      src={sub.logo_url}
                      alt={sub.title}
                      className="w-10 h-10 object-contain"
                      loading="lazy"
                      onError={(e) => { e.currentTarget.style.display = "none"; }}
                    />
                  ) : (
                    <div className="w-10 h-10 rounded-lg bg-[#C5E8FF]" />
                  )}
                </div>
                <div className="flex flex-col flex-1 gap-1 min-w-0">
                  <p className="text-[0.9375rem] font-[700] text-[#0F172A] leading-tight group-hover:text-[#0184FF] transition-colors duration-150">
                    {sub.title}
                  </p>
                  {sub.description ? (
                    <p className="text-[0.8125rem] text-[#64748B] leading-snug line-clamp-2">
                      {sub.description.replace(/<[^>]*>/g, "")}
                    </p>
                  ) : null}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* {isAddLeadOpen && (
        <AddLeadPopup
          isOpen={isAddLeadOpen}
          onClose={() => setIsAddLeadOpen(false)}
          onLeadAdded={() => {}}
          preselectedProduct={null}
          preselectedSubCategory={selectedSubCategory}
        />
      )} */}
      {(isAddLeadOpen && selectedSubCategory) && (
        <AddLeadModal
          isOpen={isAddLeadOpen}
          onClose={() => setIsAddLeadOpen(false)}
          preselectedProduct={null}
          preSelectedCategory={{
            category_id: selectedSubCategory?.category_id?.category_id,
            title: selectedSubCategory?.category_id?.title,
            description: selectedSubCategory?.category_id?.description,
            logo_url: selectedSubCategory?.category_id?.logo_url,
            is_lead_add_without_product:
              selectedSubCategory?.category_id?.is_lead_add_without_product,
          }}
          preSelectedSubCategory={
            selectedSubCategory
              ? {
                  sub_category_id: selectedSubCategory?.sub_category_id,
                  title: selectedSubCategory?.title,
                  description: selectedSubCategory?.description,
                  logo_url: selectedSubCategory?.logo_url,
                  category_id: {
                    category_id: selectedSubCategory?.category_id?.category_id,
                    title: selectedSubCategory?.category_id?.title,
                    description: selectedSubCategory?.category_id?.description,
                    logo_url: selectedSubCategory?.category_id?.logo_url,
                    is_lead_add_without_product:
                      selectedSubCategory?.category_id?.is_lead_add_without_product,
                  },
                }
              : null
          }
        />
      )}
    </>
  );
};

export default SubCategoryPage;
